import React from 'react';
import PropTypes from 'prop-types';
import PersonalisedBrandsTags from './personalised-brands-tags';
import PersonalisedSearchesTags from './personalised-searches-tags';

const PersonalisedTags = ({ scroll }) => {
    return (
        <div className="row">
            <div className="col-md-6 col-12 pb-md-0 pt-3 pt-md-5">
                <PersonalisedBrandsTags scroll={scroll} />
            </div>
            <div className="col-md-6 col-12 pb-md-0 pt-3 pt-md-5">
                <PersonalisedSearchesTags scroll={scroll} />
            </div>
        </div>
    );
};

PersonalisedTags.propTypes = {
    scroll: PropTypes.bool.isRequired
};

export default PersonalisedTags;
